import { createContext } from 'react';

const StagesFormLoadingContext = createContext<
  | {
      setJobPostingRegistrationTemplateLoading: (loading: boolean) => void;
      setAdditionalQuestionsLoading: (loading: boolean) => void;
    }
  | undefined
>(undefined);

export default StagesFormLoadingContext;
